import type { VNode } from "vue";
import Vue from "vue";
import ColumnFilterComponent from "@/components/controls/grid/columnfilters/ColumnFilterComponent.vue";
import type { CreateElement } from "vue/types/vue";
import type {
  FilterFunc,
  FilterState,
  FilterType,
} from "@/components/controls/grid/columnfilters/ColumnFilters";
import { buildApplyFilter } from "@/components/controls/grid/columnfilters/ColumnFilters";
import BmSwitch from "@/components/controls/input/BmSwitch.vue";

const booleanFilterTypes: FilterType[] = [
  {
    type: "filter_show_all",
    values: 1,
    applyFunc: () => true,
  },
  {
    type: "filter_equals",
    values: 1,
    applyFunc: (
      itemValue: boolean,
      formattedItemValue: any,
      filterValue: boolean
    ) => itemValue === filterValue,
  },
];

export function buildApplyBooleanFilter(state: FilterState): FilterFunc {
  return buildApplyFilter(state, booleanFilterTypes);
}

export default Vue.extend({
  name: "BooleanFilterComponent",
  components: { ColumnFilterComponent },
  render(createElement: CreateElement): VNode {
    return createElement(ColumnFilterComponent, {
      attrs: { ...this.$attrs },
      props: { filterTypes: booleanFilterTypes, useTwoFilters: false },
      scopedSlots: {
        control1: (props: any) => {
          return createElement(BmSwitch, {
            attrs: {
              disabled: props.filterType === "filter_show_all",
            },
            props: {
              value: props.value,
            },
            on: {
              input: (event: boolean) => {
                props.setValue(event);
              },
            },
          });
        },
      },
    });
  },
});
